import { growthEn } from './growth.en';
import { growthEs } from './growth.es';

export const growthCopy = { en: growthEn, es: growthEs };